<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="note"> </p>
<p class="BMH">A Note on the Text</p>
<p class="TNI">I have selected the letters and journal extracts that make up the text of this book from thousands of letters and several personal journals with the aim of keeping the focus on JFP’s life. I have cut letters and passages that are not necessary to the story, including a large number concerning JFP’s deliberations and negotiations with editors and publishers.</p>
<p class="TX">Passages cut from the letters are indicated by this: […]. Passages cut from the italicized interstitial material are indicated by ellipses alone.</p>
<p class="TX">I have created consistency in such matters as capitalization and corrected the very few spelling mistakes. I have added some additional paragraph breaks as JFP often sacrificed format to postage economy. I have also retained JFP’s preference for the British custom of using no period after an abbreviation if the last letter of the abbreviation is the same as the last letter of the word being abbreviated—for example, “Mr,” “Mrs,” “Fr,” “Sr,” and “Dr.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// noteontext.vue?7fb3c71e